import { render } from "./detail.vue?vue&type=template&id=13aeb842&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=13aeb842&scoped=true&lang=css"

import exportComponent from "D:\\code\\zt\\Buyer\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13aeb842"]])

export default __exports__